import React from 'react';

const IconPlay2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M44.2782 25.0316C44.2782 21.3263 34.668 15.7232 31.2702 14.1429C25.2757 11.3552 20.6974 9.56003 15.7075 9.60164C10.62 9.53658 6.85529 11.5118 5.83326 14.9717C5.13917 17.3198 4.74843 21.1432 4.80555 25.0316C4.74843 28.92 5.13917 32.7434 5.83326 35.0919C6.85529 38.5514 10.62 40.5266 15.7075 40.4616C20.6974 40.5032 25.2757 38.708 31.2702 35.9203C34.668 34.3404 44.2782 28.7369 44.2782 25.0316Z" fill="#AD1781" />
  </svg>
);

export default IconPlay2;
